/* eslint-disable jsx-a11y/anchor-is-valid */

import moment from 'moment'
import {FC, useEffect, useState} from 'react'
import {PointAdd} from '../../../../../../../_metronic/partials/widgets/map/pointAdd'
import {Licenses} from '../../../components/licenses-list/core/_models'
import {CardSystemWidgetOneLicense} from './components/card/CardSystemWidgetOneLicense'
import {CardSystemWidgetOneLicense2} from './components/card/CardSystemWidgetOneLicense2'
import {useParams} from 'react-router-dom'
import axios from 'axios'
import {KTSVG} from '../../../../../../../_metronic/helpers'
import {Skeleton} from 'primereact/skeleton'
import { MapOneLicense } from './MapOneLicense'

interface props {
  data?: Licenses
}
const API_URL = process.env.REACT_APP_API_URL || 'api'

const DashboardOneLicense: FC<props> = ({data}) => {
  const [latitude, setLatitude] = useState(0)
  const [longitude, setLongitude] = useState(0)
  const {uuid} = useParams()
  const [cardList, setCardList] = useState<any>([])
  const [indicator, setIndicator] = useState<any>()
  const [custo, setCusto] = useState<any>()

  useEffect(() => {
    let X = Math.floor(Math.random() * 10)

    if (X <= 2) {
      //Lago Coração
      setLatitude(41.3039167)
      setLongitude(-81.9016944)
    } else if (X <= 4) {
      //lago Azul
      setLatitude(38.4833889)
      setLongitude(-109.6813333)
    } else if (X <= 6) {
      //formas
      setLatitude(35.45328522)
      setLongitude(-120.499879)
    } else if (X <= 8) {
      //violao
      setLatitude(-33.867676)
      setLongitude(-63.986411)
    } else {
      //ambipar
      setLatitude(-20.31573)
      setLongitude(-40.29003)
    }
  }, [])

  useEffect(() => {
    if (uuid) {
      getReports(uuid)
    }
  }, [uuid])

  async function getReports(uuid: string) {
    const card = await axios.get(
      `${API_URL}/sga/v1/widgets/conditionings/conditioning_list_per_licenses/${uuid}`
    )
    const indicador = await axios.get(
      `${API_URL}/sga/v1/widgets/conditionings/conditioning_status_statistics_per_licenses/${uuid}`
    )

    var keys: any = Object.values(indicador.data.datasets.labels)
    let values: any = Object.values(indicador.data.datasets.values)

    let toFormat: any = values[7].toString()
    setCusto(
      new Intl.NumberFormat('pt-BR', {
        style: 'decimal',
        currency: 'BRL',
        minimumFractionDigits: 2,
      }).format(toFormat)
    )

    setCardList(card.data.datasets.values)
    setIndicator([keys, values])
    return data
  }

  return (
    <>
      {data?.license_number ? (
        <div className='row mt-1'>
          {/* inicio quinto card */}
          <div className='row '>
            <div className='col-lg-6 col-sm-6'>
              {/* condicional de loading para o card */}

              <CardSystemWidgetOneLicense
                className=''
                licenseNumber={data?.license_number || ''}
                fields={data.fields || ''}
                entrepreneur={data?.entrepreneur?.name || ''}
                issueOrgan={data?.issueOrgan?.description || ''}
                responsibles={data?.responsibles || '-'}
                file={data?.file || ''}
                enterprises={data.enterprises || ''}
              />
            </div>
            {/* fim quinto card */}

            {/* inicio quinto card */}
            <div className='col-lg-6 col-sm-6'>
              {/* condicional de loading para o card */}
              <CardSystemWidgetOneLicense2
                className=''
                issue_date={moment(data?.issue_date).format('L') || ''}
                expiration_date={moment(data?.expiration_date).format('L') || ''}
                limit_renovation={moment(data?.limit_renovation).format('L') || ''}
                issue_cost={data?.issue_cost || ' - '}
                maintenance_cost={data?.maintenance_cost || ' - '}
                renovation_cost={data?.renovation_cost || ' - '}
              />
            </div>
          </div>
          {/* fim quinto card */}

          {/* inicio quinto card */}
          <div className='row m-0'>
            <div className='col-xxl-6 col-xl-12 col-lg-12 col-sm-6 mt-5 pe-5 rounded'>
               <MapOneLicense
                  name={'Empreendimentos'}
                  description={'Empreendimentos da Licença'}
                  enterprises={data.enterprises || []}
                  licenseId={data.id} 
                  licenseUuid={data.uuid} 
                />
            </div>

            <div className='card col-xxl-6 col-xl-12 col-lg-12 col-sm-6 mt-0 mb-4 mt-5 border border-gray-300 rounded'>
              <span className='m-5 fs-3 fw-bold'>Resumo de Condicionantes / Ações</span>
              <div className='d-flex px-5 ps-3'>
                <div className='col-4 col-xxl-4  ms-3'>
                  <div className='rounded border border-dashed mb-3 border-gray-300 text-center'>
                    <div className='mt-2 fs-6 fw-bold'>Condicionantes Concluidas:</div>
                    <div className='text-success fw-bold  fs-3'>
                      {indicator ? indicator[1][3] : 0}
                    </div>
                  </div>
                  <div className='rounded border border-dashed mb-3 border-gray-300 text-center'>
                    <div className='mt-2 fs-6 fw-bold'>Condicionantes Canceladas:</div>
                    <div className='text-success fw-bold  fs-3'>
                      {indicator ? indicator[1][4] : 0}
                    </div>
                  </div>
                  <div className='rounded border border-dashed mb-3 border-gray-300 text-center'>
                    <div className='mt-2 fs-6 fw-bold'>Condicionantes Informativas:</div>
                    <div className='text-success fw-bold  fs-3'>
                      {indicator ? indicator[1][5] : 0}
                    </div>
                  </div>
                  <div className='rounded border border-dashed mb-3 border-gray-300 text-center'>
                    <div className='mt-2 fs-6 fw-bold'>Condicionantes Impositivas:</div>
                    <div className='text-success fw-bold  fs-3'>
                      {indicator ? indicator[1][6] : 0}
                    </div>
                  </div>
                  <div className='rounded border border-dashed mb-3 border-gray-300 text-center'>
                    <div className='mt-2 fs-6 fw-bold'>Custo das Condicionantes</div>
                    <div className='text-success fw-bold  fs-3'> {`R$ ${custo}`}</div>
                  </div>
                  <div className='rounded border border-dashed mb-3 border-gray-300 text-center'>
                    <div className='mt-2 fs-6 fw-bold'>Progresso de Atendimento</div>
                    <div className='fw-bold text-primary fs-2'>
                      {indicator ? indicator[1][8] : 0}%
                    </div>
                  </div>
                </div>

                <div className='col-8 col-xxl-8 ms-3  '>
                  <div
                    key='card-widget'
                    className='card card-xl-stretch mb-5 mb-xl-8 overflow-auto'
                    style={{
                      maxHeight: '300px',
                      minHeight: '300px',
                    }}
                  >
                    <div className='card-body pt-0'>
                      {cardList.map((card: any, index: any) => {
                        return (
                          <div
                            key={index}
                            className='d-flex align-items-center bg-light-success rounded p-5 mb-7'
                          >
                            <span className='svg-icon svg-icon-warning me-5'>
                              <KTSVG
                                path='/media/icons/duotune/abstract/abs027.svg'
                                className='svg-icon-1'
                              />
                            </span>
                            <div className='flex-grow-1 me-2'>
                              <span className='fw-bold'>
                                {`Condicionante ${card.conditioning_number}`}
                              </span>
                              <span className='text-muted fw-semobold d-block'>
                                <span className='text-muted fs-8 fw-semobold d-block'>
                                  Vence em {moment(card.limit_date).format('L')}
                                </span>
                              </span>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* fim quinto card */}
        </div>
      ) : (
        <>
          <div className='d-flex flex-row-fluid flex-center rounded m-0'>
            <div className=' bg-body py-15 p-20 w-100 w-xl-1200px '>
              <div className='row'>
                <div className='col-6'>
                  <Skeleton className='mb-2'></Skeleton>
                  <Skeleton width='10rem' className='mb-2'></Skeleton>
                  <Skeleton width='5rem' className='mb-2'></Skeleton>
                  <Skeleton height='2rem' className='mb-2'></Skeleton>
                  <Skeleton width='10rem' height='4rem'></Skeleton>
                </div>
                <div className='col-6'>
                  <Skeleton className='mb-2'></Skeleton>
                  <Skeleton width='10rem' className='mb-2'></Skeleton>
                  <Skeleton width='5rem' className='mb-2'></Skeleton>
                  <Skeleton height='2rem' className='mb-2'></Skeleton>
                  <Skeleton width='10rem' height='4rem'></Skeleton>
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex flex-row-fluid flex-center rounded m-0'>
            <div className=' bg-body py-15 p-20 w-100 w-xl-1200px '>
              <div className='row'>
                <div className='col-6'>
                  <Skeleton className='mb-2'></Skeleton>
                  <Skeleton width='10rem' className='mb-2'></Skeleton>
                  <Skeleton width='5rem' className='mb-2'></Skeleton>
                  <Skeleton height='2rem' className='mb-2'></Skeleton>
                  <Skeleton width='10rem' height='4rem'></Skeleton>
                </div>
                <div className='col-6'>
                  <Skeleton className='mb-2'></Skeleton>
                  <Skeleton width='10rem' className='mb-2'></Skeleton>
                  <Skeleton width='5rem' className='mb-2'></Skeleton>
                  <Skeleton height='2rem' className='mb-2'></Skeleton>
                  <Skeleton width='10rem' height='4rem'></Skeleton>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}
export {DashboardOneLicense}
